import { graphql, Link, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React, { ReactNode } from "react";

import {
  detailSmall,
  heading100,
  heading150,
  heading200,
  heading300,
  heading500,
  paragraphTextLarge,
} from "../../../stitches/combinedStyles";
import { styled } from "../../../stitches/stitches.config";
interface TextWithTitleProps {
  title: ReactNode;
  children: ReactNode;
  divider?: boolean;
}
const TextWithTitle = ({ title, children, divider }: TextWithTitleProps) => {
  const childrenArr = React.Children.toArray(children);

  return (
    <TextContent divider={divider}>
      <Title>{title}</Title>
      {childrenArr.map((child, i) => (
        <Byline key={i}>{child}</Byline>
      ))}
    </TextContent>
  );
};

export default TextWithTitle;

const TextContent = styled("div", {
  maxWidth: 900,
  margin: "0 auto",
  padding: 20,
  "@sm": { padding: 32 },

  variants: {
    divider: {
      true: {
        borderBottom: "1px solid #D9D9D9",
      },
    },
  },
});
const Title = styled("h2", {
  ...heading100,
  display: "flex",
  justifyContent: "space-between",
  lineHeight: "31px",
  marginTop: 59,
  marginBottom: 20,
  whiteSpace: "pre-line",
  "@sm": {
    ...heading150,
    paddingLeft: 0,
  },
  "@md": {
    ...heading200,
    fontWeight: 600,
    textAlign: "left",
  },
  "@lg": {
    ...heading300,
    fontWeight: 600,
  },
});
const Byline = styled("div", {
  ...detailSmall,
  marginBottom: 10,
  marginLeft: "auto",
  marginRight: "auto",
  "@md": {
    ...paragraphTextLarge,
    marginBottom: 32,
    textAlign: "left",
    marginLeft: 0,
    marginRight: 0,
  },
});
